((document, window, history) => {
	const pushState = history.pushState;
	let windowWidth = window.innerWidth;

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner__button')) {
			document.querySelector('.dtaleddesigns-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.dtaleddesigns-ui-biscuit-banner').classList.add('dtaleddesigns-ui-biscuit-banner--hide');

				window._dtaleddesigns.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner__button--close')) {
			document.querySelector('.dtaleddesigns-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.dtaleddesigns-ui-biscuit-banner').classList.add('dtaleddesigns-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	function animateText(index) {
		const letters = document.querySelectorAll('.site-logo__svg-path tspan');

		if (index < letters.length) {
			letters[ index ].style.opacity = '1';

			// Wait for a duration before animating the next letter
			setTimeout(() => {
				animateText(index + 1);
			}, 100); // You can adjust the delay as needed
		}
	}

	function watercolours() {
		const twoPI = 2 * Math.PI;
		let color = -25;
		let windowWidthGlobal = window.innerWidth;

		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');

		let width = canvas.width = window.innerWidth,
			height = canvas.height = window.innerHeight;

		window.addEventListener('resize', function() {
			if (windowWidthGlobal !== window.innerWidth) {
				width = canvas.width = window.innerWidth;
				height = canvas.height = window.innerHeight;
				document.querySelector('.site-watercolour-canvas').appendChild(canvas);
				windowWidthGlobal = width;
			}
		});

		document.querySelector('.site-watercolour-canvas').appendChild(canvas);

		function randomWiggle(wiggle) {
			return (Math.random() * wiggle) * (Math.random() < 0.5 ? -1 : 1);
		}

		function randomColor() {
			color = Math.floor((color % 360) + 25 + (15 * Math.random()));
			return 'hsl(' + color + ', 50%, 55%)';
		}

		function WaterColor(options) {
			if (!(this instanceof WaterColor)) {
				return new WaterColor(options);
			}

			for (const key in options) {
				if (options.hasOwnProperty(key)) {
					this[ key ] = options[ key ];
				}
			}

			if (!this.fill) {
				this.fill = randomColor();
			}
			this.c = Math.floor(Math.random() * 2);
			this.render();
		}

		WaterColor.prototype = {
			sides: 6,
			x: 20,
			y: 20,
			ctx: false,

			speed: 0.3,

			maxPoints: 3000,
			maxRender: 5,

			scale: false,

			buildPoints() {
				const wiggle = this.size * 0.15;
				const horizontal = Math.random() > 0.5;
				let	rotation = 0,
					x = -this.size,
					y = 0;
				const start = [x, y];

				this.points = [start];

				for (; rotation < twoPI; rotation += this.speed) {
					x += (this.size * this.speed * Math.sin(rotation) * (horizontal ? 1 : 0.7)) + randomWiggle(wiggle); // * Math.cos( (rotation/twoPI) * twoPI ) );

					y += (this.size * this.speed * Math.cos(rotation) * (horizontal ? 0.7 : 1)) + randomWiggle(wiggle); // * Math.cos( (rotation/twoPI) * twoPI) );

					this.points.push([x, y]);
				}

				this.points.push(start);

				this.originalPoints = this.points;
				return this.points;
			},

			expandPoints() {
				if (!this.points) {
					return this.buildPoints();
				}

				if (this.points.length > this.maxPoints) {
					return false;
				}

				const wiggle = this.size * 0.05;

				const p = [];
				const len = this.points.length - 1;
				let	i = 0,
					x, y, x2, y2;

				for (; i < len; i ++) {
					y = this.points[ i ][ 1 ];
					x = this.points[ i ][ 0 ];
					y2 = this.points[ i + 1 ][ 1 ];
					x2 = this.points[ i + 1 ][ 0 ];
					p.push(
						[x, y],
						[
							((x2 + x) / 2) + randomWiggle(wiggle),
							((y2 + y) / 2) + randomWiggle(wiggle)
						],
						[x2, y2]
					);
				}

				this.points = p;

				return true;
			},

			c: 0,

			render() {
				this.c ++;
				if (this.c < (this.maxRender * 3)) {
					requestAnimationFrame(this.render.bind(this));
				}
				if (this.c % 3 === 0) {
					this.draw(this.c / 3);
				}
			},

			draw(c) {
				if (this.ctx) {
					while (this.expandPoints()) {}

					const itr = (c / this.maxRender);

					ctx.setTransform(1, 0, 0, 1, 0, 0);

					ctx.globalCompositeOperation = 'hard-light';// 'xor';
					ctx.globalAlpha = 0.25 - (itr * 0.1);

					ctx.translate(this.x, this.y);
					if (this.scale) {
						ctx.scale((1 + itr) * 0.2, (1 + itr) * 0.2);
					}

					ctx.beginPath();
					ctx.moveTo(this.points[ 0 ][ 0 ], this.points[ 0 ][ 1 ]);

					for (let i = 0, len = this.points.length; i < len; i ++) {
						ctx.lineTo(this.points[ i ][ 0 ], this.points[ i ][ 1 ]);
					}

					ctx.closePath();
					ctx.fillStyle = this.fill;
					ctx.fill();

					this.points = this.originalPoints;
				}

				return this;
			}
		};

		function makeWatercolor(e) {
			let x = width * Math.random(),
				y = height * Math.random();

			if (e) {
				e = e.touches ? e.touches[0] : e;
				x = e.clientX || e.x;
				y = e.clientY || e.y;
			}

			ctx.globalAlpha = 0.02;
			ctx.setTransform(1, 0, 0, 1, 0, 0);
			ctx.fillStyle = '#FFF';
			ctx.fillRect(0, 0, width, height);

			new WaterColor({
				ctx,
				size: Math.min(width, height) * ((0.2 + Math.random()) * 0.5),
				x,
				y,
				scale: true
			});
		}

		const halfWidth = width / 2;
		const halfHeight = height / 2;

		for (let i = 0, len = 10; i < len; i ++) {
			new WaterColor({
				ctx,
				size: width * ((0.7 + Math.random()) * 0.5),
				x: halfWidth + (Math.cos((i / len) * twoPI) * halfWidth),
				y: halfHeight + (Math.sin((i / len) * twoPI) * halfHeight)
			});
		}

		setInterval(() => {
			makeWatercolor();
		}, 1000);
	}

	function productListing() {
		let page = 1;

		// Function to update the product list
		function updateProductList(categories, resetPage) {
			const productList = document.querySelector('.site-shop__product-list');
			document.querySelector('.site-shop__product-container').classList.add('site-shop__product-container--loading');
			page = resetPage ? 1 : page;

			const data = new URLSearchParams({
				action: 'productListingGetter',
				page,
				term_id: categories,
				nonce: dtaleddesignsAjaxHandler.nonce
			});

			fetch(dtaleddesignsAjaxHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': dtaleddesignsAjaxHandler.nonce
				}
			}).then((response) => response.json()).then((res) => {
				if (res.success) {
					productList.innerHTML = res.data.content;

					// Update the data-max-pages attribute with the maxPages value from the response
					productList.dataset.maxPages = res.data.maxPages;

					if (page === parseInt(res.data.maxPages)) {
						document.querySelector('.site-shop__load-more').remove();
					}

					document.querySelector('.site-shop__product-container').classList.remove('site-shop__product-container--loading');
				} else {
					console.error('There was an error!', res.data.message);
				}
			}).catch((error) => {
				console.error('There was an error!', error);
			});
		}

		// Attach change event listeners to category checkboxes
		document.querySelectorAll('.site-shop__category-filter-checkbox-input').forEach((_sel) => {
			_sel.addEventListener('change', () => {
				const selectedCategories = Array.from(document.querySelectorAll('.site-shop__category-filter-checkbox-input:checked')).map((checkbox) => checkbox.value).join(',');
				updateProductList(selectedCategories, true);
			});
		});

		// Attach click event listeners to load more buttons
		document.querySelectorAll('.site-shop__load-more').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				const button = e.target;
				const productList = button.parentNode.parentNode.querySelector('.site-shop__product-list');

				e.preventDefault();

				button.classList.add('site-shop__load-more--loading');

				const data = new URLSearchParams({
					action: 'productListingGetter',
					page: page += 1,
					term_id: productList.dataset.termId,
					nonce: dtaleddesignsAjaxHandler.nonce
				});

				fetch(dtaleddesignsAjaxHandler.ajaxurl, {
					method: 'POST',
					body: data,
					headers: {
						'Accept': 'application/json',
						'Content-type': 'application/x-www-form-urlencoded',
						'X-WP-Nonce': dtaleddesignsAjaxHandler.nonce
					}
				}).then((response) => response.json()).then((res) => {
					if (res.success) {
						productList.insertAdjacentHTML('beforeend', res.data.content);
						button.classList.remove('site-shop__load-more--loading');

						if (page === parseInt(res.data.maxPages)) {
							button.remove();
						}
					} else {
						console.error('There was an error!', res.data.message);
					}
				}).catch((error) => {
					console.error('There was an error!', error);
				});
			});
		});
	}

	function updateCart() {
		let timeout;
		const woocommerce = document.querySelectorAll('.woocommerce');
		woocommerce.forEach(function(container) {
			container.addEventListener('click', function(event) {
				if (timeout !== undefined) {
					clearTimeout(timeout);
				}
				timeout = setTimeout(function() {
					document.querySelector('.actions .button').click(); // trigger cart update
				}, 1000); // 1 second delay, half a second (500) seems comfortable too
			});
		});
	}

	function carousels(_sel) {
		if (_sel.children.length > 1) {
			const config = {
				cellAlign: 'center',
				wrapAround: true,
				draggable: true,
				pageDots: false,
				prevNextButtons: false,
				autoPlay: 6000,
				lazyLoad: false
			};

			const carousel = new Flickity(_sel, config);
		}
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.dtaleddesigns-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-shop__products')) {
			productListing();
		}

		if (document.querySelector('.site-logo__svg')) {
			animateText(0);
		}

		if (document.querySelector('.site-carousel')) {
			document.querySelectorAll('.site-carousel').forEach((_sel) => {
				carousels(_sel);
			});
		}

		if (document.querySelector('.site-watercolour-canvas')) {
			watercolours();
		}

		if (document.querySelector('.site-page__cart')) {
			updateCart();
		}

		if (document.querySelector('.site-dtaleddesigns-ui-revolver')) {
			document.querySelectorAll('[dtaleddesigns-ui="carousel"]').forEach((_sel) => {
				_sel.dtaleddesignsUiRevolverCarousel();
			});
		}

		if (document.querySelector('.site-dtaleddesigns-ui-lightbox__toggle')) {
			document.querySelectorAll('.site-dtaleddesigns-ui-lightbox__toggle').forEach((_sel) => {
				new DTaledDesignsUiLightbox(_sel);
			});
		}
	});

	window.addEventListener('resize', () => {
		if (window.innerWidth !== windowWidth) {
			watercolours();
		}
		windowWidth = window.innerWidth;
	});
})(document, window, history);
